export default "__VITE_ASSET__BDaezitn__"